<template>
  <div>
    <!-- 渲染表格 -->
    <BasicTable searchPlaceholder="航点名称" :tableColumn="tableColumn" :tableData="tableData" :actions="actions"
      :showAddButton="uBtnPermissionList.includes('airpoint-add')" :tableTitle="tableTitle" :showSearch="true"
      :current="current" :total="total" :size="size" @add-item="addItem" @detail-item="detailItem" @edit-item="editItem"
      @delete-item="deleteItem" @search-item="searchItem" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <template #customCol>
        <el-table-column prop="type" label="航点类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 0">普通航点</span>
            <span v-else-if="scope.row.type === 1">临时起降点</span>
            <span v-else-if="scope.row.type === 2">起降点</span>
          </template>
        </el-table-column>
      </template>
    </BasicTable>
    <!-- 渲染弹框 -->
    <BasicForm labelWidth="100px" :dialogVisible="dialogVisible" :dialogTitle="dialogTitle" dialogType="航点"
      :formModel="taskForm" :btnName="btnName" @submit="handleFormSubmit" @update:dialogVisible="updateDialogVisible"
      :formRules="formRules">
      <!-- 正常写本页面需要的表单项 -->
      <div style="width: 100%; height: 100%; display: flex">
        <div style="width: 40%; height: 100%">
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="航点名称" prop="name">
                <el-input v-model="taskForm.name" :disabled="ifView" placeholder="请填写航点名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="海拔高(m)" prop="altitude" :rules="[
                {
                  required: true,
                  message: '请填写海拔高(m)',
                  trigger: 'blur',
                },
                { validator: this.validateNumber, trigger: 'blur' },
              ]">
                <el-input v-model="taskForm.altitude" :disabled="ifView" placeholder="请填写海拔高(m)"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :span="20">
            <el-button type="primary" size="small" class="changeLonLat" @click="changeLonLatType">{{ displayType ===
              'decimal' ? "度分秒" : '小数'
            }}</el-button>
            <el-col :span="12">
              <el-form-item label="经度" style="margin-bottom: 0 !important;">
                <div v-if="displayType === 'decimal'" class="decimal-input">
                  <el-form-item prop="longitude" :rules="[
                    { required: true, message: '请填写经度(°)', trigger: 'blur' },
                    { validator: this.validateDecimalLongitude, trigger: 'blur' }
                  ]">
                    <el-input v-model="taskForm.longitude" :disabled="ifView" placeholder="请输入经度(小数格式)"></el-input>
                  </el-form-item>
                </div>
                <div v-else class="dms-input">
                  <el-form-item prop="longitudeDegrees" :rules="[
                    // { required: true, message: '请输入度数', trigger: 'blur' },
                    { validator: this.validateDMSLongitudeDegrees, trigger: 'blur' }
                  ]">
                    <el-input v-model="longitudeDegrees" :disabled="ifView" placeholder="度"></el-input>
                  </el-form-item>

                  <el-form-item prop="longitudeMinutes" :rules="[
                    // { required: true, message: '请输入分数', trigger: 'blur' },
                    { validator: this.validateDMSLongitudeMinutes, trigger: 'blur' }
                  ]">
                    <el-input v-model="longitudeMinutes" :disabled="ifView" placeholder="分"></el-input>
                  </el-form-item>

                  <el-form-item prop="longitudeSeconds" :rules="[
                    // { required: true, message: '请输入秒数', trigger: 'blur' },
                    { validator: this.validateDMSLongitudeSeconds, trigger: 'blur' }
                  ]">
                    <el-input v-model="longitudeSeconds" :disabled="ifView" placeholder="秒"></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" style="margin-bottom: 0 !important;">
                <div v-if="displayType === 'decimal'" class="decimal-input">
                  <el-form-item prop="latitude" :rules="[
                    { required: true, message: '请填写纬度(°)', trigger: 'blur' },
                    { validator: this.validateDecimalLatitude, trigger: 'blur' }
                  ]">
                    <el-input v-model="taskForm.latitude" :disabled="ifView" placeholder="请输入纬度(小数格式)"></el-input>
                  </el-form-item>
                </div>
                <div v-else class="dms-input">
                  <el-form-item prop="latitudeDegrees" :rules="[
                    // { required: true, message: '请输入度数', trigger: 'blur' },
                    { validator: this.validateDMSDegrees, trigger: 'blur' }
                  ]">
                    <el-input v-model="latitudeDegrees" :disabled="ifView" placeholder="度"></el-input>
                  </el-form-item>

                  <el-form-item prop="latitudeMinutes" :rules="[
                    // { required: true, message: '请输入分数', trigger: 'blur' },
                    { validator: this.validateDMSMinutes, trigger: 'blur' }
                  ]">
                    <el-input v-model="latitudeMinutes" :disabled="ifView" placeholder="分"></el-input>
                  </el-form-item>

                  <el-form-item prop="latitudeSeconds" :rules="[
                    // { required: true, message: '请输入秒数', trigger: 'blur' },
                    { validator: this.validateDMSSeconds, trigger: 'blur' }
                  ]">
                    <el-input v-model="latitudeSeconds" :disabled="ifView" placeholder="秒"></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="航点类型" prop="type">
                <el-select v-model="taskForm.type" placeholder="请选择航点类型" popper-class="adminHomeSelect"
                  :disabled="ifView">
                  <el-option v-for="option in options" :key="option.id" :label="option.name"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="select" label="省份" :rules="[
                { required: true, trigger: 'change', message: '请选择省份' },
              ]" prop="provinceCode">
                <el-select @change="handleProvinceChange" v-model="taskForm.provinceCode" placeholder="请选择省份"
                  :disabled="ifView">
                  <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                    :value="province.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item class="alarmtime" label="城市" :rules="[
                { required: false, trigger: 'change', message: '请选择城市' },
              ]">
                <el-select @change="handleCityChange" v-model="taskForm.cityCode" placeholder="请选择城市" clearable
                  :disabled="!taskForm.provinceCode || ifView">
                  <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="note" label="区/县" :rules="[
                { required: false, trigger: 'change', message: '请选择区域' },
              ]">
                <el-select v-model="taskForm.regionCode" placeholder="请选择区/县" :disabled="!taskForm.cityCode || ifView"
                  clearable>
                  <el-option v-for="district in districts" :key="district.code" :label="district.name"
                    :value="district.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="width: 60%; height: 100%">
          <div style="
              width: 95%;
              height: 100%;
              margin-left: 20px;
              padding-top: 4px;
            ">
            <SecondMap style="width: 100%; height: 100%" showType="AirPoint" :canDraw="canDraw" :airPoint="airPoint"
              @update-marker="handleUpdateMarker"></SecondMap>
          </div>
        </div>
      </div>
    </BasicForm>
  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import SecondMap from "../../common/SecondMap.vue";
import axios from "axios";
export default {
  name: "Operator",
  // 注入公共组件
  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
    SecondMap, //公共地图
  },

  data() {
    return {
      // ============表格配置信息==============
      // 列配置 label-列名，prop-对应列的字段名
      tableColumn: [
        { label: "航点名称", prop: "name" },
        { label: "纬度(°)", prop: "latitude" },
        { label: "经度（°）", prop: "longitude" },
        { label: "海拔高（m）", prop: "altitude" },
      ],
      longitudeDegrees: null,
      longitudeMinutes: null,
      longitudeSeconds: null,
      latitudeDegrees: null,
      latitudeMinutes: null,
      latitudeSeconds: null,
      displayType: 'decimal',
      tableData: [], // 列表内容数据
      actions: [],
      showAddButton: true, //是否展示新增按钮
      tableTitle: "航点管理", //表格标题
      taskForm: {
        name: "",
        latitude: "",
        longitude: "",
        altitude: "",
        type: "",
        provinceName: "",
        provinceCode: "",
        cityName: "",
        cityCode: "",
        regionName: "",
        regionCode: "",
      }, // 表单数据绑定
      dialogVisible: false, //初始不展示对话框
      dialogTitle: "",
      btnName: "",
      ifView: false,
      provinces: [], //省份
      // selectedCity: "",
      cities: [], //城市
      // selectedProvince: "",
      districts: [], //县
      // selectedDistrict: "",
      options: [
        { id: 0, name: "普通航点" },
        { id: 1, name: "临时起降点" },
        { id: 2, name: "起降点" },
      ],
      // 定义表单必填校验
      formRules: [
        { label: "航点名称", prop: "name" },
        { label: "航点类型", prop: "type" },
      ],
      canDraw: false, //用户是否可以绘制
      airPoint: [], //用户选择航点
      total: 0, //总条数
      current: 1, //当前页数
      size: 18, //显示几条
      searchKey: "", //搜索关键字
    };
  },
  mounted() {
    this.getAllProvince();
    this.uBtnPermissionList.includes("airpoint-check") &&
      this.actions.push({ label: "查看", type: "view" });
    this.uBtnPermissionList.includes("airpoint-modify") &&
      this.actions.push({ label: "修改", type: "edit" });
    this.uBtnPermissionList.includes("airpoint-delete") &&
      this.actions.push({ label: "删除", type: "delete" });
    // 请求表格配置和数据
    this.$nextTick(function () {
      this.getWaypointData();
    });
  },
  computed: {
    uBtnPermissionList() {
      return this.getPageBtnRole("airPoint") || [];
    },
  },
   ws: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getLastStatus()
        }
      }
    },
  methods: {
    //度分秒转小数
    convertDMStoDecimal(dms, direction) {
      // 基础验证
      if (
        isNaN(dms.degrees) ||
        isNaN(dms.minutes) ||
        isNaN(dms.seconds)
      ) {
        return null;
      }

      // 计算小数部分
      const decimalPart = dms.degrees + (dms.minutes / 60) + (dms.seconds / 3600);

      // 处理方向符号
      let sign = 1;
      if (direction) {
        direction = direction.toUpperCase();
        if (direction === 'S' || direction === 'W') {
          sign = -1;
        }
      }

      return (decimalPart * sign).toFixed(8);
    },
    convertDecimalToDMS(decimal) {
      decimal = Number(decimal);
      const degrees = Math.floor(decimal);
      const minutes = Math.floor((decimal - degrees) * 60);
      const seconds = Math.floor(
        Math.round((decimal - degrees - minutes / 60) * 3600 * 1000) / 1000
      ); // 保留千分位
      return [degrees, minutes, seconds];
    },
    changeLonLatType() {
      this.displayType = this.displayType === 'decimal' ? 'dms' : 'decimal';
      if (this.displayType === 'decimal') {
        if (this.longitudeDegrees && this.longitudeMinutes && this.longitudeSeconds) {
          this.taskForm.longitude = this.convertDMStoDecimal({
            degrees: Number(this.longitudeDegrees),
            minutes: Number(this.longitudeMinutes),
            seconds: Number(this.longitudeSeconds)
          }, 'E');
        }else{
          this.longitudeDegrees = null;
          this.longitudeMinutes = null;
          this.longitudeSeconds = null;
        }
        if (this.latitudeDegrees && this.latitudeMinutes && this.latitudeSeconds) {
          this.taskForm.latitude = this.convertDMStoDecimal({
            degrees: Number(this.latitudeDegrees),
            minutes: Number(this.latitudeMinutes),
            seconds: Number(this.latitudeSeconds)
          }, 'N');
        }else{
          this.latitudeDegrees = null;
          this.latitudeMinutes = null;
          this.latitudeSeconds = null;
        }
      } else {
        if (this.taskForm.longitude || this.taskForm.latitude) {
          const lon = this.convertDecimalToDMS(this.taskForm.longitude);
          const lat = this.convertDecimalToDMS(this.taskForm.latitude);
          this.longitudeDegrees = lon[0];
          this.longitudeMinutes = lon[1];
          this.longitudeSeconds = lon[2];
          this.latitudeDegrees = lat[0];
          this.latitudeMinutes = lat[1];
          this.latitudeSeconds = lat[2];
        }
      }
    },
    // 关闭对话框时获取子组件传过来的dialogVisible状态
    updateDialogVisible(newVal) {
      this.dialogVisible = newVal;
      this.displayType = 'decimal'
    },
    // 重置表单
    resetForm() {
      this.taskForm = {
        name: "",
        latitude: "",
        longitude: "",
        altitude: "",
        type: "",
        provinceName: "",
        provinceCode: "",
        cityName: "",
        cityCode: "",
        regionName: "",
        regionCode: "",
      };
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.getWaypointData();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.getWaypointData();
    },
    getAllProvince() {
      //获取省份
      this.getRequest("/uav-task-server/region/getAllProvince").then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.provinces = oData.data;
        }
      });
    },
    getCitiesByProvince(provinceCode) {
      //获取城市
      return this.getRequest(
        `/uav-task-server/region/getCity?provinceCode=${provinceCode}`
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.cities = oData.data;
        }
      });
    },
    getDistrictsByCity(cityCode) {
      //获取县城
      return this.getRequest(
        `/uav-task-server/region/getDistrict?cityCode=${cityCode}`
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.districts = oData.data;
        }
      });
    },
    handleProvinceChange(provinceCode) {
      // 清空市和区绑定的值
      this.taskForm.regionCode = "";
      this.taskForm.cityCode = "";
      this.getCitiesByProvince(provinceCode);
    },
    handleCityChange(cityCode) {
      // 清空区绑定的值
      this.taskForm.regionCode = "";
      this.getDistrictsByCity(cityCode);
    },
    getWaypointData() {
      this.getRequest(
        `/uav-task-server/cpoint/queryAllCPoint?pagesize=${this.size}&currentpage=${this.current}&keyword=${this.searchKey}`
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let pointDataList = oData.data.list;
            this.total = oData.data.total;
            this.current = oData.data.pageNum;
            pointDataList.forEach((pointData, index) => {
              // switch (pointData.type) {
              //   case 0:
              //     pointDataList[index].type = "普通航点";
              //     break;
              //   case 1:
              //     pointDataList[index].type = "临时起降点";
              //     break;
              //   case 2:
              //     pointDataList[index].type = "起降点";
              //     break;
              // }
            });
            this.tableData = pointDataList;
          } else if (oData.code != 401) {
            let msg = "请求数据失败!";
            if (!this.isEmptyStr(res.msg)) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => { });
    },
    // 处理包含航点信息
    getAirpointNames(airpoints) {
      // 提取每个航点的name属性，并拼接
      return airpoints.map((point) => point.name).join(", ");
    },
    //用户填写经纬度
    blurLongitude() {
      this.airPoint = [
        Number(this.taskForm.longitude),
        Number(this.taskForm.latitude),
      ];
    },
    blurLatitude() {
      this.airPoint = [
        Number(this.taskForm.longitude),
        Number(this.taskForm.latitude),
      ];
    },
    handleUpdateMarker(data) {
      this.taskForm.longitude = data[0] ? data[0].toString() : null;
      this.taskForm.latitude = data[1] ? data[1].toString() : null;
      if (this.taskForm.longitude || this.taskForm.latitude) {
          const lon = this.convertDecimalToDMS(this.taskForm.longitude);
          const lat = this.convertDecimalToDMS(this.taskForm.latitude);
          this.longitudeDegrees = lon[0];
          this.longitudeMinutes = lon[1];
          this.longitudeSeconds = lon[2];
          this.latitudeDegrees = lat[0];
          this.latitudeMinutes = lat[1];
          this.latitudeSeconds = lat[2];
        }else{
          this.longitudeDegrees = null;
          this.longitudeMinutes = null;
          this.longitudeSeconds = null;
          this.latitudeDegrees = null;
          this.latitudeMinutes = null;
          this.latitudeSeconds = null;
        }
    },
    // 新增 打开弹框，如有下拉选项等数据可在此发请求加载
    addItem() {
      this.canDraw = true;
      this.airPoint = [null, null];
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.btnName = "提交"; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.resetForm();
    },
    // 查看
    detailItem(item) {
      try {
        axios
          .get(`/uav-task-server/cpoint/getById?id=${item.id}`)
          .then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data;
              this.taskForm = data;
              this.taskForm.cityCode = data.cityName;
              this.taskForm.regionCode = data.regionName;
              this.dialogVisible = true;
              this.canDraw = false;
              this.airPoint = [item.longitude, item.latitude];
              // this.dialogVisible = true;
              this.dialogTitle = "查看";
              this.btnName = "关闭";
              this.ifView = true; //仅查看，不可编辑
            }
          });
      } catch (err) {
        this.$message.error({
          message: oData.msg,
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () { },
        });
      }

      // this.taskForm = { ...item };
    },
    // 修改 TODO
    editItem(item) {
      try {
        axios
          .get(`/uav-task-server/cpoint/getById?id=${item.id}`)
          .then((res) => {
            if (res.data.code === 0) {
              let data = res.data.data;
              this.taskForm = { ...data };
              if (data.provinceName) {
                this.taskForm.provinceCode = data.provinceCode;
                this.getCitiesByProvince(data.provinceCode).then(() => {
                  if (data.cityName) {
                    this.taskForm.cityCode = data.cityCode;
                    this.getDistrictsByCity(data.cityCode).then(
                      () => {
                        if (data.regionName) {
                          this.taskForm.regionCode = data.regionCode;
                        } else {
                          this.taskForm.regionCode = '';
                        }
                        this.dialogVisible = true;
                      }
                    );
                  } else {
                    this.taskForm.regionCode = '';
                    this.taskForm.cityCode = ''
                    this.dialogVisible = true;
                  }
                });
              } else {
                this.taskForm.provinceCode = ''
                this.taskForm.regionCode = '';
                this.taskForm.cityCode = ''
                this.dialogVisible = true;
              }


              this.canDraw = true;
              this.airPoint = [item.longitude, item.latitude];
              // this.dialogVisible = true;
              this.dialogTitle = "修改";
              this.btnName = "提交"; //如果是“提交”可不写该行
              this.ifView = false; //可编辑
            }
          });
      } catch (err) {
        this.$message.error({
          message: oData.msg,
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () { },
        });
      }
      // this.taskForm = { ...item };
    },
    // 删除 TODO--
    deleteItem(itemId) {
      try {
        // 向API发送DELETE请求
        axios.get(`/uav-task-server/cpoint/deleteById?id=${itemId}`);
        this.getWaypointData();
      } catch (error) { }
    },

    // 点击确认
    async handleFormSubmit(formData) {
      // console.log('formData-->', formData)
      // 处理表单提交，根据 dialogTitle 判断是新增还是编辑操作
      // 设置请求头，告诉服务器我们发送的是JSON格式数据
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      if (this.dialogTitle === "新增") {
        // 执行新增操作 请求后端接口
        let params = {
          ...this.taskForm,
          longitude: this.displayType !== 'decimal' ? this.convertDMStoDecimal({ degrees: Number(this.longitudeDegrees), minutes: Number(this.longitudeMinutes), seconds: Number(this.longitudeSeconds) }, 'E') : this.taskForm.longitude,
          latitude: this.displayType !== 'decimal' ? this.convertDMStoDecimal({ degrees: Number(this.latitudeDegrees), minutes: Number(this.latitudeMinutes), seconds: this.latitudeSeconds }, 'N') : this.taskForm.latitude,
          regionCode: this.taskForm.regionCode
            ? this.taskForm.regionCode
            : this.taskForm.cityCode
              ? this.taskForm.cityCode
              : this.taskForm.provinceCode,
        };
        const response = await axios.post(
          "/uav-task-server/cpoint/addCPoint",
          params,
          config
        );
        this.resetForm();
        if (response.data.code == 0) {
          this.displayType = 'decimal'
          this.$message({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
          this.$nextTick(function () {
            this.getWaypointData();
          });
        } else {
          this.$message.error({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { },
          });
        }
      } else if (this.dialogTitle === "修改") {
        // 执行修改操作 请求后端接口
        let params = {
          ...this.taskForm,
          longitude: this.displayType !== 'decimal' ? this.convertDMStoDecimal({ degrees: Number(this.longitudeDegrees), minutes: Number(this.longitudeMinutes), seconds: Number(this.longitudeSeconds) }, 'E') : this.taskForm.longitude,
          latitude: this.displayType !== 'decimal' ? this.convertDMStoDecimal({ degrees: Number(this.latitudeDegrees), minutes: Number(this.latitudeMinutes), seconds: this.latitudeSeconds }, 'N') : this.taskForm.latitude,
          regionCode: this.taskForm.regionCode
            ? this.taskForm.regionCode
            : this.taskForm.cityCode
              ? this.taskForm.cityCode
              : this.taskForm.provinceCode,
        };
        const response = await axios.post(
          "/uav-task-server/cpoint/updatecpoint",
          params,
          config
        );
        if (response.data.code == 0) {
          const index = this.tableData.findIndex(
            (user) => user.id === formData.id
          );
          if (index !== -1) {
            this.tableData.splice(index, 1, formData);
          }
          this.$message.success({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () { },
          });
          this.$nextTick(function () {
            this.getWaypointData();
          });
        } else {
          this.$message.error({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { },
          });
        }
      } else if (this.dialogTitle === "查看") {
        // 执行查看操作
        this.getWaypointData();
      }
      this.dialogVisible = false;
    },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.getWaypointData();
    },
    //验证经度
    validateDecimalLongitude(rule, value, callback) {
      // 正则表达式验证经纬度格式
      const longitudeRegex =
        /^-?((1[0-7]\d|\d{1,2})(\.\d{0,8})?|180(\.0{0,8})?)$/;
      if (!value) {
        callback(new Error("经度不能为空"));
      } else if (!longitudeRegex.test(value)) {
        callback(new Error("小数点后最多8位例:-123.45678912"));
      } else {
        callback();
      }
    },
    // 验证度分秒格式 - 度数
    validateDMSLongitudeDegrees(rule, value, callback) {
      if (this.longitudeDegrees === '' || this.longitudeDegrees === null || this.longitudeDegrees === undefined || isNaN(this.longitudeDegrees)) {
        return callback(new Error('请输入经度度数'));
      }
      // 验证范围 -180 到 180 度
      if (this.longitudeDegrees < -180 || this.longitudeDegrees > 180) {
        return callback(new Error('经度度数范围应为-180至180度'));
      }

      // 边界条件：当度数为±180时，分秒必须为0
      if ((this.longitudeDegrees === 180 || this.longitudeDegrees === -180) &&
        (this.longitudeMinutes !== 0 || this.longitudeSeconds !== 0)) {
        return callback(new Error('经度为±180度时，分秒必须为0'));
      }

      callback();
    },

    // 验证度分秒格式 - 分数
    validateDMSLongitudeMinutes(rule, value, callback) {
      if (this.longitudeMinutes === '' || this.longitudeMinutes === null || this.longitudeMinutes === undefined || isNaN(this.longitudeMinutes)) {
        return callback(new Error('请输入经度分数'));
      }

      // 验证范围 0 到 59
      if (this.longitudeMinutes < 0 || this.longitudeMinutes > 59) {
        return callback(new Error('经度分数范围应为0至59'));
      }

      callback();
    },

    // 验证度分秒格式 - 秒数
    validateDMSLongitudeSeconds(rule, value, callback) {
      if (this.longitudeSeconds === '' || this.longitudeSeconds === null || this.longitudeSeconds === undefined || isNaN(this.longitudeSeconds)) {
        return callback(new Error('请输入经度秒数'));
      }

      // 验证范围 0 到 59.999
      if (value < 0 || value > 59.999) {
        return callback(new Error('经度秒数范围应为0至59.999'));
      }

      callback();
    },
    //验证纬度
    validateDecimalLatitude(rule, value, callback) {
      // 小数格式验证逻辑
      const latitudeRegex = /^-?(([1-8]?\d)(\.\d{0,8})?|90(\.0{0,8})?)$/;
      if (!value) {
        callback(new Error("坐标点不能为空"));
      } else if (!latitudeRegex.test(value)) {
        callback(new Error("小数点后最多8位例:45.67891234"));
      } else {
        callback();
      }
    },

    validateDMSDegrees(rule, value, callback) {
      if (this.latitudeDegrees === '' || this.latitudeDegrees === null || this.latitudeDegrees === undefined || isNaN(this.latitudeDegrees)) {
        return callback(new Error('请输入纬度度数'));
      }
      if (this.latitudeDegrees < -90 || this.latitudeDegrees > 90) {
        return callback(new Error('纬度度数范围应为-90至90度'));
      }
      callback();
    },

    validateDMSMinutes(rule, value, callback) {
      if (this.latitudeMinutes === '' || this.latitudeMinutes === null || this.latitudeMinutes === undefined || isNaN(this.latitudeMinutes)) {
        return callback(new Error('请输入纬度分数'));
      }
      if (this.latitudeMinutes < 0 || this.latitudeMinutes > 59) {
        return callback(new Error('纬度分数范围应为0至59'));
      }
      callback();
    },

    validateDMSSeconds(rule, value, callback) {
      if (this.latitudeSeconds === '' || this.latitudeSeconds === null || this.latitudeSeconds === undefined || isNaN(this.latitudeSeconds)) {
        return callback(new Error('请输入纬度秒数'));
      }
      if (this.latitudeSeconds < 0 || this.latitudeSeconds > 59.999) {
        return callback(new Error('纬度秒数范围应为0至59.999'));
      }
      // 整体验证（需要在提交时执行）
      callback();
    },
    // 数字校验 允许小数点
    validateNumber(rule, value, callback) {
      if (value === "" || !/^-?[1-9]\d*|0$/.test(value)) {
        callback(new Error("请填写有效的数字"));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
.leaflet-draw {
  display: none !important;
}

>>>.el-form .el-form-item {
  margin-bottom: 44px !important;
}

>>>.el-form {
  padding: 0 !important;
}

>>>.el-dialog__header {
  /* background-image: url(../../img/common/tableHead.png); */
  /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
  padding: 20px 20px 0px 40px;
  background: url(../../assets/img/2dmap/pop_bg.png) no-repeat;
  background-position: 18px 20px;
}

/* >>> .el-form-item__label{
  width: 100px !important;
} */
>>>#container .el-dialog__header {
  padding: 15px 20px 0px 40px !important;
}

>>>#container .el-dialog__headerbtn {
  top: 7px !important;
}

.changeLonLat {
  right: 0;
  top: -31px;
  position: absolute;
  cursor: pointer;
  z-index: 2;
  width: 66px;
}

.dms-input>>>.el-form-item__content,
.decimal-input>>>.el-form-item__content {
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/AirPoint.vue